import apiClient from './api'

export const cartService = {
  /**
   * Sincronizza il carrello locale con il server
   * @param {Array} items - Array di oggetti { productId, quantity, color, size }
   */
  /**
   * Sincronizza il carrello locale con il server
   * @param {Array} items - Array di oggetti { variantId, quantity }
   */
  /**
   * Sincronizza il carrello locale con il server
   * @param {Array} items - Array di oggetti { variantId, quantity }
   */
  async sync(items) {
    // Endpoint: POST /api/Carts/sync
    const response = await apiClient.post('/Carts/sync', { items })
    return response.data
  },

  /**
   * Recupera la lista articoli dal server
   */
  async getCartItems() {
    // Endpoint: GET /api/CartItems
    const response = await apiClient.get('/CartItems')
    return response.data
  },

  /**
   * Recupera il dettaglio carrello (per ottenere il cartId)
   */
  async getCartDetails() {
    // Nota: lo swagger o la doc suggeriscono che il carrello dell'utente loggato 
    // può essere recuperato senza ID o tramite un endpoint specifico.
    // Usiamo /Carts per ottenere l'oggetto carrello che contiene il cartId
    const response = await apiClient.get('/Carts')
    return response.data
  },

  /**
   * Aggiunge un articolo al carrello sul server
   */
  async addItem(_, variantId, quantity) {
    // Endpoint: POST /api/CartItems
    // Passiamo cartId: 0 come da nuove specifiche backend (identificazione automatica via Token)
    const response = await apiClient.post('/CartItems', {
      cartId: 0,
      variantId,
      quantity
    })
    return response.data
  },

  /**
   * Rimuove un articolo dal carrello sul server
   */
  async removeItem(cartItemId) {
    // Endpoint: DELETE /api/CartItems/{id}
    const response = await apiClient.delete(`/CartItems/${cartItemId}`)
    return response.data
  },

  /**
   * Aggiorna la quantità di un articolo sul server
   */
  async updateQuantity(cartItemId, quantity) {
    // Endpoint: PUT /api/CartItems/{id}
    // Passiamo cartId: 0 nel body se richiesto, anche se ignorato dal server
    const response = await apiClient.put(`/CartItems/${cartItemId}`, {
      cartId: 0,
      quantity
    })
    return response.data
  },

  /**
   * Svuota il carrello sul server
   * @param {number} cartId - ID del carrello da eliminare
   */
  async clearCart(cartId) {
    // Endpoint: DELETE /api/Carts/{cartId} come da specifiche backend
    const response = await apiClient.delete(`/Carts/${cartId}`)
    return response.data
  }
}

export default cartService
